// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__A6GOr","rotation":"LoadingIndicator_rotation__3Tr55"};